import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { Link } from 'gatsby';
import { theme } from '../../styles/GlobalStyles';
import { BodyText } from '../Global';
import Icon from '../Icon';
import EssentialIcon from './essential.svg';
import StandardIcon from './standard.svg';
import ProfessionalIcon from './professional.svg';
import EnterpriseIcon from './enterprise.svg';


const SliderWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 57px auto 108px;
`;
const PricingCard = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 15px;
  width: calc(100% - 20px) !important;
  height: 437px;
  padding: 27px 23px 37px;
  border: 1px solid ${theme.borderColor.lightGray};
  border-top: 6px solid ${props => props.borderColor};
  outline: none;
  .popular {
    position: absolute;
    top: -20px;
    left: calc(50% - 62.5px);
    z-index: 2;
    width: 125px;
    padding: 6px 0;
    text-align: center;
    color: ${theme.heading.dark};
    font-size: 16px;
    line-height: 19.2px;
    background: ${props => props.borderColor};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.09);
    border-radius: 3px
  }
  h3 {
    font-size: 24px;
    line-height: 28.8px;
    font-weight: 700;
    color: ${theme.textColor.darkGrayText};
  }
  .price {
    font-size: 16px;
    line-height: 19.2px;
    font-weight: 700;
    color: ${theme.textColor.darkGrayText};
    span {
      font-size: 36px;
      line-height: 43.2px;
      font-weight: 900;
      color: ${theme.priceColor.price};
      vertical-align: -webkit-baseline-middle;
    }
  }
  .annually {
    color: ${theme.textColor.darkGrayText};
  }
  .monthly {
    color: ${theme.textColor.suvaGray};
  }
  img {
    margin: auto;
  }
  button {
    position: absolute;
    width: calc(100% - 40px);
    text-align: center;
    left: 20px;
    bottom: 40px;
    font-size: 16px;
    line-height: 19.2px;
    color: ${theme.priceColor.price};
    background: ${theme.body.dark};
    border: 1.5px solid ${theme.borderColor.darkGray}; 
    border-radius: 6px;
    outline: none;
    padding: 8px 0 9px;
    svg {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      margin-bottom: 2px;
    }
    :hover {
      cursor: pointer;
      color: ${theme.body.dark};
      background: ${theme.borderColor.darkGray};
      svg {
        path {
          fill: white;
        }
      }
    }
  }
`;
const ImageWrap = styled.div`
  margin-top: ${props => props.mt};
  margin-bottom: ${props => props.mb};
`;
const Description = styled.div`
  position: absolute;
  bottom: 93px;
  width: calc(100% - 40px);
  font-size: 18px;
  line-height: 21.6px;
  font-weight: 400;
  color: ${theme.textColor.darkGrayText};
`;
const PricingSlider = () => {
  const settings = {
    infinite: true,
    autoPlay: true,
    slidesToShow: 4,
    speed: 500,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          className: 'center',
          centerMode: true,
          centerPadding: '10%',
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerPadding: '10%',
        }
      }
    ]
  };
  return (
    <SliderWrap>
      <Slider {...settings}>
        <PricingCard borderColor={theme.priceColor.essential}>
          <h3>Essential</h3>
          <div className="price">
            USD
            <span> $0</span>
          </div>
          <ImageWrap mt="38px" mb="50.71px">
            <img src={EssentialIcon} alt="essential plan" />
          </ImageWrap>
          <Description>Light task management for Slack teams.</Description>
          <Link to="/">
            <button type="button">Get Started</button>
          </Link>
        </PricingCard>
        <PricingCard borderColor={theme.priceColor.standard}>
          <div className="popular">
            Most Popular
          </div>
          <h3>Standard</h3>
          <div className="price">
            USD
            <span> $4.95</span>
          </div>
          <BodyText className="annually">
            Per user, per month billed annually
          </BodyText>
          <BodyText className="monthly">
            $7.95 billed monthly
          </BodyText>
          <ImageWrap mt="12px" mb="11px">
            <img src={StandardIcon} alt="standard plan" />
          </ImageWrap>
          <Description>Essential plus basic project management features.</Description>
          <Link to="/">
            <button type="button">Try for free</button>
          </Link>
        </PricingCard>
        <PricingCard borderColor={theme.priceColor.professional}>
          <h3>Professional</h3>
          <div className="price">
            USD
            <span> $9.95</span>
          </div>
          <BodyText className="annually">
            Per user, per month billed annually
          </BodyText>
          <BodyText className="monthly">
            $14.95 billed monthly
          </BodyText>
          <ImageWrap mt="12px" mb="11px">
            <img src={ProfessionalIcon} alt="professional plan" />
          </ImageWrap>
          <Description> Manage long term projects and advance customization</Description>
          <Link to="/">
            <button type="button">Try for free</button>
          </Link>
        </PricingCard>
        <PricingCard borderColor={theme.priceColor.enterprise}>
          <h3>Enterprise</h3>
          <ImageWrap mt="85px" mb="55.21px">
            <img src={EnterpriseIcon} alt="enterprise plan" />
          </ImageWrap>
          <Description>Roll out Workast to your whole organization</Description>
          <Link to="/">
            <button type="button">
              <Icon name="contactIcon" color={theme.priceColor.price} />
              Contact sales
            </button>
          </Link>
        </PricingCard>
      </Slider>
    </SliderWrap>
  );
};

export default PricingSlider;
